import React from 'react'
import PropTypes from 'prop-types'

const Container = ({children, ...props}) => (
  <div {...props}>{children}</div>
)

Container.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Container



// WEBPACK FOOTER //
// ./src/sections/flow/components/container.jsx